<app-image-link-list></app-image-link-list>
<div class="flex-container">
  <div class="container">
    <div class="f-col custom-row">
      <div class="f-row twoColLayout main-content">
        <div class="col title-section">
          <h2 class="title">Simplify your Business Travel management</h2>
          <!-- <p class="link-section m-top-8x m-bottom-8x"> Already a Saudia Business member?&nbsp; <a class="cursor-pointer text-decoration-underline" (keydown.enter)="_ciamService.login()" tabindex="0" role="button" (click)="_ciamService.login()">Login</a></p> -->
          <p class="link-section m-top-8x m-bottom-8x"> Already a Saudia Business member?&nbsp; <a class="cursor-pointer text-decoration-underline" (keydown.enter)="goToLanding()" tabindex="0" role="button" (click)="goToLanding()">Login</a></p>
           <p class="link-section m-top-8x m-bottom-8x">
            QL development login?&nbsp;
            <a
              class="cursor-pointer text-decoration-underline"
              routerLink="/login"
              >Login</a
            >
          </p>

          <button mat-button class="button--primary-large" routerLink="/intermediate" (click)="registerNow()" aria-label="Register Now"> Register Now <mat-icon fontSet="material-symbols-outlined" aria-hidden="true">arrow_forward</mat-icon> </button>
        </div>

        <div class="col right-contxt-col">
          <p>
            Join and unlock unparalleled advantages for your company’s travel.
            Designed to streamline and enhance business travel, Saudia Business
            provides a dedicated platform to book, manage, and reward business
            trips with ease.
          </p>
        </div>
      </div>

      <mat-divider></mat-divider>

      <div class="f-row twoColLayout main-content">
        <div class="title-section">
          <h2 class="title">How it Works for Your Business</h2>
          <p class="link-section m-top-8x m-bottom-8x">
            Saudia Business is a one stop self service booking portal for
            businesses like yours!
          </p>
        </div>

        <div class="right-contxt-col">
          <div class="col unlock-benefits-container">
            <ul>
              <li>
                <span class="icon-section">
                  <mat-icon fontSet="material-symbols-outlined" class="done-icon"> done </mat-icon>
                </span>
                <div class="list-content">
                  <h3>Earn Business Points with Every Trip</h3>
                  <p>
                    Maximize value with collective business points that your
                    company accumulates from all employee travel. Continue to
                    reward individual employees with frequent flyer miles, while
                    your business earns points to redeem for exclusive perks and
                    future travel savings.
                  </p>
                </div>
              </li>

              <li>
                <span class="icon-section">
                  <mat-icon fontSet="material-symbols-outlined" class="done-icon"> done </mat-icon>
                </span>
                <div class="list-content">
                  <h3>Enhanced Employee Travel Experience</h3>
                  <p>
                    Enable your employees to travel with confidence and comfort.
                    With exclusive benefits such as flexible bookings, priority
                    options, and simplified upgrades, Saudia Business elevates
                    every journey.
                  </p>
                </div>
              </li>

              <li>
                <span class="icon-section">
                  <mat-icon fontSet="material-symbols-outlined" class="done-icon"> done </mat-icon>
                </span>
                <div class="list-content">
                  <h3>Enhanced Employee Travel Experience</h3>
                  <p>
                    Enable your employees to travel with confidence and comfort.
                    With exclusive benefits such as flexible bookings, priority
                    options, and simplified upgrades, Saudia Business elevates
                    every journey.
                  </p>
                </div>
              </li>

              <li>
                <span class="icon-section">
                  <mat-icon fontSet="material-symbols-outlined" class="done-icon"> done </mat-icon>
                </span>
                <div class="list-content">
                  <h3>Travel Policy Integration</h3>
                  <p>
                    Simplify travel policy management by embedding your
                    organization’s travel rules directly into the booking
                    process. Ensure compliance while offering travelers an easy,
                    policy-driven booking experience.
                  </p>
                </div>
              </li>

              <li>
                <span class="icon-section">
                  <mat-icon fontSet="material-symbols-outlined" class="done-icon"> done </mat-icon>
                </span>
                <div class="list-content">
                  <h3>Streamlined Approval Process</h3>
                  <p>
                    Control travel approvals with ease. The integrated workflow
                    allows managers to review and approve bookings efficiently,
                    ensuring both flexibility and compliance with company
                    guidelines.
                  </p>
                </div>
              </li>

              <li>
                <span class="icon-section">
                  <mat-icon fontSet="material-symbols-outlined" class="done-icon"> done </mat-icon>
                </span>
                <div class="list-content">
                  <h3>Real-Time Reporting & Insights</h3>
                  <p>
                    Access powerful dashboards with real-time data, providing
                    full visibility into spending, trends, and travel patterns.
                    Optimize future travel budgets with clear insights that
                    support data-driven decision-making.
                  </p>
                </div>
              </li>

              <li>
                <span class="icon-section">
                  <mat-icon fontSet="material-symbols-outlined" class="done-icon"> done </mat-icon>
                </span>
                <div class="list-content">
                  <h3>Dedicated Support</h3>
                  <p>
                    Rely on our dedicated team of business travel experts,
                    available to assist with bookings, modifications, and
                    tailored solutions to support your organization’s unique
                    travel needs.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>

      <!-- <div class="f-row twoColLayout main-content">
                <div class="title-section">
                    <h2 class="title">Why choose Saudia Business?</h2>
                    <p class="link-section m-top-8x m-bottom-8x">The premier choice for your business travel needs.</p>
                </div>

                <div class="right-contxt-col">
                    <p>Saudia Business is a comprehensive, self-service portal tailored for all your business travel
                        needs. From booking and policy integration to real-time tracking and rewards, it offers a
                        seamless experience for both companies and employees.</p>
                </div>
            </div>

            <mat-divider></mat-divider> -->

      <div class="f-row twoColLayout main-content">
        <div class="title-section full-section">
          <h2 class="title">Let’s Get You Onboard</h2>
          <p class="link-section m-top-8x m-bottom-8x">
            Join us today and elevate your business travel experience!
          </p>
          <button
            mat-button
            class="button--primary-large"
            routerLink="/Signup"
            (click)="registerNow()"
          >
            Register Now
            <mat-icon fontSet="material-symbols-outlined">arrow_forward</mat-icon>
          </button>
        </div>
      </div>

      <mat-divider></mat-divider>

      <div class="f-row twoColLayout main-content contactAbout-section">
        <div class="f-col">
          <h4 class="title-text">Related FAQs</h4>
          <a href="#" target="_blank" rel="noopener noreferrer" class="description-text m-top-8x"
            >View all FAQs <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon></a
          >
        </div>

        <div class="f-col login-brief-container">
          <mat-accordion class="mat-accordion faq__accordion">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Who can register on the Saudia Business portal from the
                  company?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="mat-panel-body-custom ng-star-inserted">
                <p>
                  The user who will act as the travel administrator and point of
                  contact from the company should register on the portal.
                </p>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Our company has an existing travel desk; can we still register
                  our company on the portal?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="mat-panel-body-custom ng-star-inserted">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Vulputate risus mattis ornare at egestas tortor.
                </p>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  What is the duration of the account verification process?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="mat-panel-body-custom ng-star-inserted">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Vulputate risus mattis ornare at egestas tortor.
                </p>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  What is Saudia Business Points Program ?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="mat-panel-body-custom ng-star-inserted">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Vulputate risus mattis ornare at egestas tortor.
                </p>
              </div>
            </mat-expansion-panel>
            
          </mat-accordion>
        </div>

      </div>
    </div>
  </div>
</div>
